import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import RmaLogic from "../Logic/Logic.ts";
import ErrorBoundary from "./ErrorBoundary";

class TrackResults extends Component {
  constructor(props) {
    super();

    this.state = {
      logic: new RmaLogic(),
      trackingInfo: [],
    };
  }

  componentDidMount = async () => {
    let trackingInfo = JSON.parse(localStorage.getItem("trackingInfo") || "");
    this.setState({ trackingInfo: trackingInfo });
  };

  closeClick = () => {
    localStorage.setItem("trackingInfo", "");
    this.props.history.replace("/pages/track");
  };

  getTrackingUrl = (carrier, number) => {
    switch (carrier) {
      case "USPS":
        return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${number}`;
      case "FedEx":
        return `https://www.fedex.com/fedextrack/?trknbr=${number}`;
      case "UPS":
        return `https://www.ups.com/track?loc=en_US&requester=QUIC&tracknum=${number}/trackdetails`;
      default:
        return "";
    }
  };

  render() {
    return (
      <ErrorBoundary>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={0}
        >
          <div>
            {Array.isArray(this.state.trackingInfo) &&
              this.state.trackingInfo.map((trackingInfo, trackingIndex) => {
                const trackingUrl = this.getTrackingUrl(
                  trackingInfo.carrier,
                  trackingInfo.tracking_number
                );
                return (
                  <div key={trackingIndex}>
                    {trackingInfo.carrier ? (
                      <h4
                        style={{
                          textAlign:
                            trackingInfo?.details?.length > 0
                              ? "left"
                              : "center",
                        }}
                      >
                        {trackingInfo.carrier} -&nbsp;
                        <a
                          ref={(el) => {
                            if (el) {
                              el.style.setProperty(
                                "color",
                                "blue",
                                "important"
                              );
                              el.style.setProperty(
                                "text-decoration",
                                "underline",
                                "important"
                              );
                            }
                          }}
                          className="spr-summary-actions-newreview"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={trackingUrl}
                        >
                          {trackingInfo.tracking_number}
                        </a>
                      </h4>
                    ) : (
                      <></>
                    )}
                    <h5>{trackingInfo.summary}</h5>
                    <ul>
                      {trackingInfo.carrier === "USPS"
                        ? Array.isArray(trackingInfo.details) &&
                          trackingInfo.details.map((detail, index) => (
                            <li key={index}>{detail.desc}</li>
                          ))
                        : Array.isArray(trackingInfo.details) &&
                          trackingInfo.details.map((detail, index) => (
                            <li key={index}>
                              {detail.desc} -{" "}
                              {new Date(detail.date).toUTCString()}
                              {detail.location.trim().length === 0
                                ? ""
                                : ` - ${detail.location}`}
                            </li>
                          ))}
                    </ul>
                    {!trackingInfo?.details?.length &&
                      !trackingInfo?.summary && (
                        <p>
                          A status update is not yet available on your package.
                          It will be available when the shipper provides an
                          update or the package is given to USPS. Check back
                          soon.
                        </p>
                      )}
                  </div>
                );
              })}
          </div>
        </Grid>
      </ErrorBoundary>
    );
  }
}

const TrackResultsWithRouter = withRouter(TrackResults);
export default TrackResultsWithRouter;
